module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["divider"],
    style: {
      width: this.width ? this.width + 'px' : '100%'
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-4c766cb6!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-divider/index.vue
// module id = 609
// module chunks = 0 1